import IPercentualTransferenciaMotorista from '../entities/IPercentualTransferenciaMotorista'
import { IPagamentoRepository } from '../repositories/IPagamentoRepository'

export interface IGetPercentualTransferenciaMotorista {
  execute(frotistaId: number): Promise<IPercentualTransferenciaMotorista>
}
export default class GetPercentualTransferenciaMotoristaImpl
  implements IGetPercentualTransferenciaMotorista
{
  constructor(private readonly motoristaRepository: IPagamentoRepository) {}
  async execute(
    frotistaId: number,
  ): Promise<IPercentualTransferenciaMotorista> {
    return this.motoristaRepository.get(frotistaId)
  }
}
